import { queryOptions } from "@tanstack/react-query"

import { getIsomorphicSupabaseClient } from "@repo/supabase/isomorphic-client"
import { logger } from "@repo/utils/logger"
import { createUnitsService } from "../units/units.service"

export const personalAccountQueryKeys = {
  all: ["personal-account"],
  personalAccount: (userId: string) => [
    ...personalAccountQueryKeys.all,
    userId,
  ],
}

export const getPersonalAccountQueryOptions = (userId: string) =>
  queryOptions({
    queryKey: personalAccountQueryKeys.personalAccount(userId),
    queryFn: async () => {
      try {
        const supabase = await getIsomorphicSupabaseClient()
        const unitsService = createUnitsService(supabase)
        const personalAccount = await unitsService.getPersonalAccountUnit()

        if (!personalAccount) {
          throw new Error("Personal account not found")
        }

        // Mainly checked for type narrowing
        if (personalAccount.is_primary_owner !== true) {
          throw new Error("You are not the primary owner of this account")
        }

        return personalAccount
      } catch (error) {
        logger.error("Error fetching personal account", { error })

        return null
      }
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    enabled: !!userId,
  })
